import { useState } from "react";
import { useNavigate, useLocation, Navigate } from "react-router-dom";

import { api, ApiError } from "../lib/api";
import { getToken, setSession, type AdminUser } from "../lib/auth";

type LoginResponse = { token: string; user: AdminUser };

export function LoginPage() {
  const nav = useNavigate();
  const loc = useLocation();
  const from = (loc.state as { from?: string } | null)?.from || "/projects";

  if (getToken()) return <Navigate to={from} replace />;

  const [email, setEmail]     = useState("admin@kexicapital.com");
  const [password, setPwd]    = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState<string | null>(null);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      const res = await api.post<LoginResponse>("/api/admin/auth/login", { email, password });
      setSession(res.token, res.user);
      nav(from, { replace: true });
    } catch (err) {
      if (err instanceof ApiError && err.status === 401) setError("邮箱或密码错误");
      else setError("登录失败，请稍后再试");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <form className="login-card" onSubmit={submit}>
        <h1>珂玺 · 资本</h1>
        <div className="sub">KEXI CAPITAL · 管理后台</div>
        <div className="field">
          <label>邮箱</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoFocus
            required
          />
        </div>
        <div className="field">
          <label>密码</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPwd(e.target.value)}
            required
          />
        </div>
        {error && <div className="error" style={{ marginBottom: 10 }}>{error}</div>}
        <button type="submit" className="btn btn-primary" style={{ width: "100%" }} disabled={loading}>
          {loading ? "登录中…" : "登录"}
        </button>
      </form>
    </div>
  );
}
